export default "__VITE_PUBLIC_ASSET__24f2d427__"